// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_vwQtB","backToTop":"index_backToTop_p7M1o"};